import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { logoutAction } from "../slices/authSlice";

// export const url ="http://127.0.0.1:8990"
export const url =process.env.REACT_APP_PRODUCTION_URL_V1
  // process.env.NODE_ENV === "development"
  //   ? process.env.REACT_APP_DEVELOPMENT_URL_V1
  //   : process.env.REACT_APP_PRODUCTION_URL_V1;

const rawBaseQuery = fetchBaseQuery({
  baseUrl: url,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as any).auth?.token;
    console.log("token", token);
    if (token) {
      headers.set("authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

export const baseQuery: typeof rawBaseQuery = async (
  args,
  api,
  extraOptions
) => {
  const result = await rawBaseQuery(args, api, extraOptions);
  if (
    result.error &&
    ((result.error as any).originalStatus == 401 ||
      (result.error as any).originalStatus == 403)
  ) {
    api.dispatch(logoutAction());
  } 
  return result;
};
